import React, { useState } from "react";
import { BellRing, Check } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

// Shown only for out-of-stock products — customers leave an email and get one automatic
// "back in stock" message the moment an admin restocks the item.
export const RestockNotify = ({ flavorId, compact = false }) => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) { toast.error("Enter a valid email"); return; }
    setBusy(true);
    try {
      await api.post("/restock/subscribe", { flavor_id: flavorId, email: email.trim() });
      setDone(true);
      toast.success("We'll email you the moment it's back");
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="flex items-center gap-2 border border-green-600/40 bg-green-600/10 px-3 py-2 text-xs" data-testid="restock-done">
        <Check className="h-4 w-4 shrink-0 text-green-600" /> You're on the list — we'll email you when it's back in stock.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="border border-primary/40 bg-primary/5 p-3" data-testid="restock-notify">
      <div className="mb-2 flex items-center gap-2 text-xs font-semibold text-primary">
        <BellRing className="h-4 w-4 shrink-0" /> Notify me when it's back in stock
      </div>
      <div className={`flex ${compact ? "flex-col" : "flex-wrap"} items-stretch gap-2`}>
        <input
          type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com" data-testid="restock-email"
          className="min-w-0 flex-1 rounded-none border border-border bg-background px-3 py-2 text-sm"
        />
        <button type="submit" disabled={busy} data-testid="restock-submit"
          className="shrink-0 bg-primary px-4 py-2 text-xs font-semibold text-primary-foreground transition-transform enabled:hover:-translate-y-0.5 disabled:opacity-50">
          {busy ? "Saving…" : "Notify me"}
        </button>
      </div>
    </form>
  );
};
